import { createFileRoute, notFound } from "@tanstack/react-router";
import {
  getStrategyPartnerMetaDescription,
  getStrategyPartnerMetaTitle,
} from "~/features/strategy-partner/strategy-partner-copy";
import { getStrategyPartner } from "~/features/strategy-partner/strategy-partner-data";

export const Route = createFileRoute("/_app/sp/$partner")({
  head: ({ params }) => ({
    meta: [
      { title: getStrategyPartnerMetaTitle(params.partner) },
      {
        content: getStrategyPartnerMetaDescription(params.partner),
        name: "description",
      },
    ],
  }),
  loader: ({ params }) => {
    if (!getStrategyPartner(params.partner)) {
      throw notFound();
    }
  },
});
